export default {
      id: "ic-plan-papier-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-papier-usage",
      toString: function () {
        return this.url;
      }
    }